import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { NavLink, useLocation } from 'react-router';
import { squadsResponseSchema } from '@pm/contracts';
import { api } from '../api/client.js';

export function SquadNavigation() {
  const location = useLocation();
  const [open, setOpen] = useState(location.pathname.startsWith('/production/squads'));
  const squads = useQuery({
    queryKey: ['squads'],
    queryFn: () => api('/api/v1/squads', {}, squadsResponseSchema),
  });
  const activeSquads = (squads.data?.data ?? []).filter((squad) => squad.active);
  const expanded = open;
  if (squads.isSuccess && activeSquads.length === 0) return null;
  return (
    <div className="squad-sidebar">
      <button
        type="button"
        className="sidebar-squad-toggle"
        aria-expanded={expanded}
        aria-controls="squad-sidebar-list"
        onClick={() => setOpen(!expanded)}
      >
        Squads <span aria-hidden="true">⌄</span>
      </button>
      <div className="sidebar-nav-links" id="squad-sidebar-list" hidden={!expanded}>
        {activeSquads.map((squad) => (
          <NavLink key={squad.id} to={`/production/squads/${squad.id}`}>
            {squad.name}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
